import { render } from "./TopTransactions.vue?vue&type=template&id=caae476c&scoped=true"
import script from "./TopTransactions.vue?vue&type=script&lang=js"
export * from "./TopTransactions.vue?vue&type=script&lang=js"

import "./TopTransactions.vue?vue&type=style&index=0&id=caae476c&scoped=true&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caae476c"],['__file',"src/components/TopTransactions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "caae476c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('caae476c', __exports__)) {
    console.log('reload')
    api.reload('caae476c', __exports__)
  }
  
  module.hot.accept("./TopTransactions.vue?vue&type=template&id=caae476c&scoped=true", () => {
    console.log('re-render')
    api.rerender('caae476c', render)
  })

}


export default __exports__